/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2026 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import * as React from "react";
import iconBulkUploadLight from "components/Plans/images/bulk-upload.svg";
import iconBulkUploadDark from "components/Plans/images/bulk-upload-dark.svg";
import iconEnhanceMoreLight from "components/Plans/images/enhance-more.svg";
import iconEnhanceMoreDark from "components/Plans/images/enhance-more-dark.svg";
import iconAdjustStrengthLight from "components/Plans/images/adjust-strength.svg";
import iconAdjustStrengthDark from "components/Plans/images/adjust-strength-dark.svg";
import iconCrownLight from "components/Plans/images/crown.svg";
import iconCrownDark from "components/Plans/images/crown-dark.svg";
import iconVideoLight from "./images/video-light.svg";
import iconVideoDark from "./images/video-dark.svg";
import iconVideoPlayLight from "./images/video-play-icon-light.svg";
import iconVideoPlayDark from "./images/video-play-icon-dark.svg";
import iconUploadLight from "components/Plans/images/upload-icon-light.svg";
import iconUploadDark from "components/Plans/images/upload-icon-dark.svg";
import downloadImg from "images/EnhanceSpeech/download-icon-light.svg";
import downloadImgDark from "components/Plans/images/download-icon-dark.svg";
import iconSpeakersLight from "images/Studio/speakers-icon-light.svg";
import iconSpeakersDark from "components/Plans/images/speakers-icon-dark.svg";

export enum IconMode {
  light,
  dark,
}

export interface IconComponentProps
  extends React.DetailedHTMLProps<
    React.ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  > {
  mode: IconMode;
}

const mkIconComponent: (args: {
  lightUrl: string;
  darkUrl: string;
}) => React.FC<IconComponentProps> = ({ lightUrl, darkUrl }) => {
  return ({ mode, ...props }): JSX.Element => {
    return (
      <img {...props} src={mode === IconMode.light ? lightUrl : darkUrl} />
    );
  };
};

export const IconBulkUpload = mkIconComponent({
  lightUrl: iconBulkUploadLight,
  darkUrl: iconBulkUploadDark,
});

export const IconAdjustStrength = mkIconComponent({
  lightUrl: iconAdjustStrengthLight,
  darkUrl: iconAdjustStrengthDark,
});

export const IconEnhanceMore = mkIconComponent({
  lightUrl: iconEnhanceMoreLight,
  darkUrl: iconEnhanceMoreDark,
});

export const IconCrown = mkIconComponent({
  lightUrl: iconCrownLight,
  darkUrl: iconCrownDark,
});

export const IconVideo = mkIconComponent({
  lightUrl: iconVideoLight,
  darkUrl: iconVideoDark,
});

export const IconDownload = mkIconComponent({
  lightUrl: downloadImg,
  darkUrl: downloadImgDark,
});

export const IconSpeakers = mkIconComponent({
  lightUrl: iconSpeakersLight,
  darkUrl: iconSpeakersDark,
});

export const IconVideoPlay = mkIconComponent({
  lightUrl: iconVideoPlayLight,
  darkUrl: iconVideoPlayDark,
});

export const IconUpload = mkIconComponent({
  lightUrl: iconUploadLight,
  darkUrl: iconUploadDark,
});
